<!-- Header del Modal -->
<div class="flex items-start p-4">
  <div class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30">
    <mat-icon class="text-indigo-600 dark:text-indigo-400" style="font-size: 24px; width: 24px; height: 24px;">
      warehouse
    </mat-icon>
  </div>
  <div class="ml-4 flex-1">
    <h2 class="text-xl font-bold mb-1 text-gray-900 dark:text-white">
      Gestionar Almacenes
    </h2>
    <p class="text-sm text-gray-600 dark:text-gray-400">
      <span class="font-semibold">{{ data.materialCode }}</span> - {{ data.materialName }}
    </p>
    <p class="text-xs text-gray-500 dark:text-gray-500 mt-1">
      Asignar almacenes donde el material estará disponible
    </p>
  </div>
</div>

<!-- Content del Modal -->
<mat-dialog-content class="overflow-y-auto" style="max-height: 60vh; min-height: 400px;">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-12">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="mt-4 text-sm text-gray-600 dark:text-gray-400">Cargando almacenes...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading" class="space-y-6">

    <!-- Toggle: Disponible en todos los almacenes -->
      <app-toggle-option
        [(ngModel)]="availableInAll"
        (ngModelChange)="onAvailableInAllChange($event)"
        title="Disponible en todos los almacenes"
        description="Activa esta opción si el material estará disponible en todos los almacenes del sistema"
        icon="warehouse"
        iconColor="indigo">
      </app-toggle-option>

    <!-- Info message cuando "todos los almacenes" está activo -->
    <div *ngIf="availableInAll" class="flex items-start gap-3 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
      <mat-icon class="text-blue-600 dark:text-blue-400 flex-shrink-0" style="font-size: 20px; width: 20px; height: 20px;">
        info_outline
      </mat-icon>
      <div class="flex-1 text-sm text-blue-800 dark:text-blue-300">
        <p class="font-medium mb-1">Material disponible globalmente</p>
        <p>Este material estará disponible en todos los almacenes del sistema sin restricciones.</p>
      </div>
    </div>

    <!-- Sección de selección individual (solo si no está "todos los almacenes") -->
    <div *ngIf="!availableInAll" class="">

      <!-- Barra de búsqueda -->
      <div class="relative">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Buscar almacenes</mat-label>
          <input
            matInput
            [formControl]="searchControl"
            placeholder="Buscar por nombre o código..."
            type="text">
          <mat-icon matPrefix class="text-gray-400">search</mat-icon>
          <button
            *ngIf="searchControl.value"
            mat-icon-button
            matSuffix
            (click)="clearSearch()"
            type="button">
            <mat-icon class="text-gray-400">close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Checkbox maestro y contador -->
      <div class="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
        <div class="flex items-center gap-3">
          <mat-checkbox
            [checked]="isAllFilteredSelected()"
            [indeterminate]="isSomeFilteredSelected() && !isAllFilteredSelected()"
            (change)="toggleAllFiltered()"
            color="primary"
            class="flex-shrink-0">
          </mat-checkbox>
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Seleccionar todos los almacenes{{ searchControl.value ? ' filtrados' : '' }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-xs font-medium text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 px-3 py-1 rounded-full">
            {{ getSelectedFilteredCount() }}/{{ getFilteredCount() }}
          </span>
        </div>
      </div>

      <!-- Lista de almacenes -->
      <div class="flex flex-col gap-y-2 mt-2" style="max-height: 400px; overflow-y: auto;">

        <!-- Warehouse items -->
        <div
          *ngFor="let warehouse of filteredWarehouses"
          class="warehouse-card flex items-center gap-3 p-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-indigo-300 dark:hover:border-indigo-600 hover:shadow-sm transition-all cursor-pointer"
          (click)="toggleWarehouse(warehouse._id.toString())">

          <mat-checkbox
            [checked]="isWarehouseSelected(warehouse._id.toString())"
            (click)="$event.stopPropagation()"
            (change)="toggleWarehouse(warehouse._id.toString())"
            color="primary"
            class="flex-shrink-0">
          </mat-checkbox>

          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 flex-shrink-0">
              <mat-icon class="text-indigo-600 dark:text-indigo-400" style="font-size: 20px; width: 20px; height: 20px;">
                warehouse
              </mat-icon>
            </div>

            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2">
                <span *ngIf="warehouse.externalKeys?.code" class="text-xs font-bold text-indigo-600 dark:text-indigo-400 uppercase">
                  {{ warehouse.externalKeys.code }}
                </span>
                <span class="text-sm font-medium text-gray-900 dark:text-white truncate">
                  {{ warehouse.name }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state: No warehouses found -->
        <div *ngIf="filteredWarehouses.length === 0" class="flex flex-col items-center justify-center py-12 text-center">
          <div class="w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4">
            <mat-icon class="text-gray-400" style="font-size: 32px; width: 32px; height: 32px;">
              search_off
            </mat-icon>
          </div>
          <p class="text-sm font-medium text-gray-900 dark:text-white mb-1">
            No se encontraron almacenes
          </p>
          <p class="text-xs text-gray-500 dark:text-gray-500">
            Intenta con otro término de búsqueda
          </p>
        </div>
      </div>

      <!-- Info: Total seleccionados -->
      <div *ngIf="getSelectedCount() > 0" class="flex items-center gap-2 p-3 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
        <mat-icon class="text-green-600 dark:text-green-400 flex-shrink-0" style="font-size: 20px; width: 20px; height: 20px;">
          check_circle
        </mat-icon>
        <span class="text-sm text-green-800 dark:text-green-300">
          <strong>{{ getSelectedCount() }}</strong> almacén{{ getSelectedCount() !== 1 ? 'es' : '' }} seleccionado{{ getSelectedCount() !== 1 ? 's' : '' }}
        </span>
      </div>

    </div>
  </div>
</mat-dialog-content>

<!-- Footer del Modal -->
<mat-dialog-actions class="flex justify-between items-center border-t border-gray-200 dark:border-gray-700 pt-4 mt-6">
  <div class="flex items-center gap-2">
    <mat-icon
      *ngIf="hasChanges()"
      class="text-orange-500"
      style="font-size: 18px; width: 18px; height: 18px;"
      matTooltip="Hay cambios sin guardar">
      warning
    </mat-icon>
    <span *ngIf="hasChanges()" class="text-xs text-orange-600 dark:text-orange-400 font-medium">
      Cambios sin guardar
    </span>
  </div>

  <div class="flex gap-2">
    <button
      mat-button
      (click)="onCancel()"
      [disabled]="isSaving"
      class="text-gray-700 dark:text-gray-300">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="!hasChanges() || isSaving">
      <mat-icon *ngIf="isSaving" class="animate-spin mr-2" style="font-size: 18px; width: 18px; height: 18px;">
        refresh
      </mat-icon>
      {{ isSaving ? 'Guardando...' : 'Guardar Cambios' }}
    </button>
  </div>
</mat-dialog-actions>
